import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiTetheringErrorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_tethering_error"}/>
}
